export function getGroupPageLink(groupKey) {
    return `?q=${groupKey}`;
}
